















import { Prop, Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import ID from "../../ID";

@Component({
    components: {
        BPopover
    }
})
export default class PrivatePopover extends Vue {
    @Prop() target!: string;
    @Prop({ type: Boolean }) show!: boolean;
    @Prop() container!: string;
    @Prop() width!: number;

    private myId = ID.next();

    private get _show() {
        return this.show;
    }

    private set _show(val: boolean) {
        this.onShowHandle(val);

        const el = document.getElementById("popover-" + this.myId);
        if (el) {
            el.style.width = this.width + "px";
            el.style.maxWidth = "100%";
        }
        this.$emit("update:show", val);
    }

    private scrollHandle() {
        this._show = false;
    }

    private onShowHandle(val: boolean) {
        const parents = PrivatePopover.getParentsListScroll(this.$parent.$el, true);

        parents.forEach(parent => {
            if (val)
                parent.addEventListener("scroll", this.scrollHandle);
            else
                parent.removeEventListener("scroll", this.scrollHandle);
        });
    }

    private static getParentsListScroll(element: any, includeHidden: boolean): HTMLElement[] {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === "absolute";
        const overflowRegex = includeHidden
            ? /(auto|scroll|hidden)/
            : /(auto|scroll)/;
        if (style.position === "fixed") return [document.body];
        const parents = [];
        for (let parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static") {
                continue;
            }
            if (
                overflowRegex.test(
                    style.overflow + style.overflowY + style.overflowX
                )
            )
                // return parent;
                parents.push(parent);
        }
        // return document.body
        parents.push(document.body);
        return parents;
    }
}
